import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { ScrollView, View } from 'react-native'
import { tv } from 'tailwind-variants'

const quoteModal = tv({
  slots: {
    backdrop: 'fixed inset-0 z-[9999] flex items-center justify-center bg-black/50',
    panel: 'mx-4 w-full max-w-lg rounded-xl bg-white px-4 py-5',
    scrollPanel: 'mx-2 max-h-[85vh] w-[96vw] max-w-lg overflow-hidden rounded-2xl bg-white',
    scrollArea: 'px-5 py-4',
  },
})

export const quoteModalStyles = quoteModal()

export const QuoteModal = ({
  onClose,
  scrollable = false,
  children,
}: {
  onClose: () => void
  scrollable?: boolean
  children: React.ReactNode
}) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [])

  return createPortal(
    <div
      className={quoteModalStyles.backdrop()}
      role="button"
      tabIndex={0}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose()
        }
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          onClose()
        }
      }}
    >
      {scrollable ? (
        <View className={quoteModalStyles.scrollPanel()}>
          <ScrollView className={quoteModalStyles.scrollArea()}>{children}</ScrollView>
        </View>
      ) : (
        <View className={quoteModalStyles.panel()}>{children}</View>
      )}
    </div>,
    document.body
  )
}
